import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { array, object, string } from "yup";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";
import BlogForm from "../Layouts/BlogForm";
import { BlogFormValues } from "src/models/Blog.model";
import {
  useGetBlogByIdQuery,
  useUpdateBlogByIdMutation,
} from "src/services/BlogService";

type Props = {
  onClose: () => void;
  selectedBlogId: string;
};

const EditBlogWrapper = ({ onClose, selectedBlogId }: Props) => {
  // Form Initial Values
  const [items, setItems] = useState<any>({});

  const { isLoading, isFetching, data } = useGetBlogByIdQuery(selectedBlogId);
  const [updateBlogById] = useUpdateBlogByIdMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);
  const initialValues: BlogFormValues = {
    title: items?.title || "",
    description: items?.description || "",
    image: items?.image || "",
    tags: items?.tags || [],
  };
  // Validation Schema
  const validationSchema = object().shape({
    title: string().required("Please enter title"),
    image: string().required("Please add image"),
    description: string().required("please write description"),
    tags: array()
      .of(string().trim().min(1, "Tag cannot be empty")) // each tag must be valid
      .min(1, "Please add at least one tag") // must have at least 1
      .required("Please add at least one tag"),
  });

  // Handle Submit
  const handleSubmit = (
    values: BlogFormValues,
    { setSubmitting, resetForm }: FormikHelpers<BlogFormValues>
  ) => {
    const payload = {
      title: values.title,
      description: values.description,
      image: values.image,
      tags: values.tags,
    };
    updateBlogById({
      id: selectedBlogId,
      body: payload,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="lg" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <BlogForm
              formikProps={formikProps}
              onClose={onClose}
              formType="EDIT"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditBlogWrapper;
